import { render, staticRenderFns } from "./view-wrap.vue?vue&type=template&id=d2baba22&"
import script from "./view-wrap.vue?vue&type=script&lang=js&"
export * from "./view-wrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports